<div class="am-inbox">
    @if (useFastIconType) {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.Menu"
            [displayMode]="MenuDisplayMode.FastIcon"
            badgePosition="FastIcon"
            iconClass="ui-icon ui-icon-size-lg"
            [badgeClass]="isCH ? 'badge-size-sm' : 'theme-spot-filled'"
            [processClick]="false"
            (click)="processClick($event, item, false)" />
    } @else {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.Menu"
            [displayMode]="MenuDisplayMode.Icon"
            badgePosition="icon"
            iconClass="ui-icon ui-icon-size-lg"
            [badgeClass]="isCH ? 'badge-size-sm' : 'theme-spot-filled'"
            [processClick]="false"
            (click)="processClick($event, item, false)" />
    }

    @if (!isCH) {
        <div class="inbox-count">
            @if (newMessagesCount) {
                <span class="inbox-count-txt">{{ newMessagesText }}</span>
            }
        </div>
    }
</div>
